export const POST_FORGOT_PASSWORD = 'POST_FORGOT_PASSWORD';
export const POST_FORGOT_PASSWORD_SUCCESS = 'POST_FORGOT_PASSWORD_SUCCESS';
export const POST_FORGOT_PASSWORD_ERROR = 'POST_FORGOT_PASSWORD_ERROR';

export const POST_SET_NEW_PASSWORD = 'POST_SET_NEW_PASSWORD';
export const POST_SET_NEW_PASSWORD_SUCCESS = 'POST_SET_NEW_PASSWORD_SUCCESS';
export const POST_SET_NEW_PASSWORD_ERROR = 'POST_SET_NEW_PASSWORD_ERROR';
